class generalHelper {
	constructor() {
		this.bindResponsiveTable();
		this.bindGoogleAnlyticsEventTracking();
		this.bindCareers();
	}
	bindResponsiveTable() {
		var tables = Array.from(document.querySelectorAll('table'));
		tables.forEach((table, i) => {
			table.classList.add('table');
			if (!table.parentNode.classList.contains('table-responsive')) {
				var wrapper = document.createElement('div');
				wrapper.classList.add('table-responsive')
				table.parentNode.insertBefore(wrapper, table);
				wrapper.appendChild(table);
			}
		});
	}

	bindGoogleAnlyticsEventTracking() {
		// Event Tracking
		$('a, button, submit, input[type="submit"], label').on('click', function (event) {
			var $this = $(this);
			var category;
			var label;
			var setCategory = function () {
				category = $('#page_title').text();
				//console.log(category);
				return category;
			};
			var setLabel = function () {
				label = $this.text()
				//console.log(label);
				return label;
			};

			if ($this.attr("data-ga-category") == null) {
				category = setCategory();
				label = setLabel();
			} else {
				category = $this.attr("data-ga-category");
				label = $this.attr("data-ga-label");
			}
			//check it ga is set
			if (typeof ga !== 'undefined') {
				ga('send', 'event', category, event.type, label);
			}
			//check if _gaq is set
			if (typeof _gaq !== 'undefined') {
				_gaq.push(['_trackEvent', category, event.type, label]);
			}
		});


		$(document).on("click", "#acsLoginForm a#google-button, #acsLoginForm a#facebook-button, #acsLoginForm a#yahoo-button", function () {
			var $this = $(this);
			var $label = $($this).attr('id');
			ga('send', 'event', 'ACS Login', event.type, $label);
		});

		$(document).on("click", "#acsLoginForm input[type='submit'].acs_create", function () {
			var $this = $(this);
			var $label = $($this).val();
			ga('send', 'event', 'ACS Login', event.type, $label);
		});


	}

	bindCareers() {
		$(document).ready(function () {
			$.ajax({
				type: "GET",
				url: "https://accusoft.applicantpro.com/feeds/diversity_by_domain.xml",
				dataType: "xml",
				success: parseXml
			});
		});

		function parseXml(xml) {
			$("[data-careers]").html("<div class='row' id='careers-content'></div>");
			$(xml).find("job").each(function () {
				var jobtitle = $(this).find("title").text();
				jobtitle = jobtitle.replace(/[a-zA-Z]+[0-9]{3} - /g, "");

				$("#careers-content").append("<div class='col-sm-4'><a class='career-block' target='_blank' href='" + $(this).find("url").text() + "'><h5>" + jobtitle + "</h5><hr /><p><i class='fa fa-user' aria-hidden='true'></i>  " + $(this).find("department").text() + "</p><p><i class='fa fa-inbox' aria-hidden='true'></i>  " + $(this).find("employmentType").text() + "</p><p><i class='fa fa-globe' aria-hidden='true'></i>  " + $(this).find("city").text() + ", " + $(this).find("state").text() + "</p></a></div>");
			});
		}
	}
}
window.app.add('general', new generalHelper());